import { Box, Stack, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

import { Note } from '../types/notes.types';

interface NoteListItemProps {
    note: Note;
    isSelected: boolean;
    isChecked: boolean;
    onSelect: () => void;
    onToggleCheck: () => void;
}

export const NoteListItem: React.FC<NoteListItemProps> = ({
    note,
    isSelected,
    onSelect,
}) => {
    const getPlainText = (html: string) => {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    };

    const notePreview = note.note ? getPlainText(note.note) : '';

    return (
        <Box
            sx={{
                px: 1.5,
                py: 1.5,
                cursor: 'pointer',
                backgroundColor: isSelected ? 'rgba(60, 45, 225, 0.1)' : 'transparent',
                borderRadius: '8px',
                transition: 'background-color 0.2s',
                '&:hover': {
                    backgroundColor: theme => isSelected ? 'rgba(60, 45, 225, 0.1)' : theme.palette.action.hover,
                },
            }}>
            <Stack flexDirection="row" alignItems="center" gap={1}>
                <Box sx={{ flex: 1, minWidth: 0, pr: 0.5 }} onClick={onSelect}>
                    <Stack flexDirection="column" gap={0.25}>
                        <Stack flexDirection="row" alignItems="center" gap={0.75}>
                            <Typography
                                sx={{
                                    fontSize: 16,
                                    fontWeight: 700,
                                    lineHeight: '24px',
                                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                                    color: theme => theme.palette.text.primary,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    flex: 1,
                                }}>
                                {note.title}
                            </Typography>
                            <Box
                                component="i"
                                sx={{
                                    fontSize: 14,
                                    flexShrink: 0,
                                    color: theme => theme.palette.text.secondary,
                                }}
                                className={note.visibility === 'public' ? 'fi-br-world' : 'fi-br-lock'}
                            />
                        </Stack>
                        <Stack
                            flexDirection="row"
                            alignItems="center"
                            gap={1}
                            sx={{
                                fontSize: 13,
                                fontWeight: 500,
                                lineHeight: '16px',
                                color: theme => theme.palette.text.secondary,
                            }}>
                            <Typography
                                sx={{
                                    fontSize: 'inherit',
                                    fontWeight: 'inherit',
                                    lineHeight: 'inherit',
                                    color: 'inherit',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    flex: 1,
                                }}>
                                {notePreview}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: 'inherit',
                                    fontWeight: 'inherit',
                                    lineHeight: 'inherit',
                                    color: 'inherit',
                                    flexShrink: 0,
                                }}>
                                {moment(note.createdAt).fromNow()}
                            </Typography>
                        </Stack>
                    </Stack>
                </Box>
            </Stack>
        </Box>
    );
};
